import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { WmsOrderDetailDto, WmsOrderHeaderDto } from "src/dtos/wmsOrder/wmsOrderDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface KSK1030_R01Dto {
	wmsOrderHeaderDto: KSK1030_R01HeaderDto;
	wmsOrderDetailDtoList: KSK1030_R01DetailDto[];
	wmsStockLotDtoList: Record<string, KSK1030_R01LotDto[]>;
}

export interface KSK1030_R01HeaderDto extends WmsOrderHeaderDto {
	salesOrderNo: string;
	dueDt: string;
	warehouseNm?: string;
}

export const defaultKSK1030_R01HeaderDto: KSK1030_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	wmsOrderNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	orderDt: formatDate(new Date()),
	inoutType: '',
	inoutClass: '230', // 영업출고
	customCd: '',
	customNm: '',
	deadlineDt: formatDate(new Date()),
	inoutMethod: '',
	empNo: '',
	empNm: '',
	orderAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	inoutStatus: '',
	approveFlg: '',
	closeTag: 'N',
	remark: '',

	warehouseCd: '',
	warehouseNm: '',
	salesOrderNo: '',
	dueDt: formatDate(new Date()),

	inserted: false,
	isModified: false
}

export interface KSK1030_R01DetailDto extends WmsOrderDetailDto {
	stockQty: number;
	updateTransportQty: number;
	orderQtyView: number;
	cancelQty: number;
}

export const defaultKSK1030_R01DetailDto: KSK1030_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	wmsOrderNo: '',
	itemNo: '',
	itemNm: '',
	itemSpec: '',
	modelNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	orderDt: formatDate(new Date()),
	itemSeq: 0,
	itemCd: '',
	itemStatus: '',
	orderUnit: '',
	orderQty: 0,
	cancelQty: 0,
	dcAmt: 0,
	orderPrice: 0,
	orderAmt: 0,
	transportQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',

	stockQty: 0,
	updateTransportQty: 0,
	orderQtyView: 0,

	inserted: false,
	isModified: false
}

export interface KSK1030_R01LotDto extends WmsStockLotDto {
	inputOutQty: number;
}

export const defaultKSK1030_R01LotDto: KSK1030_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	inputOutQty: 0,

	inserted: false,
	isModified: false,
}
